const urlRelatoriosLog = "/v1/RelatoriosDeLog";

const service = {
  methods: {
    $obterRelatorioLogDisciplina(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioDeLogDisciplina`, params);
    },
    $obterRelatorioLogCSVDisciplina(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioDeLogDisciplinaCsv`, params);
    },
    $obterRelatorioLogPDFDisciplina(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioDeLogDisciplinaPdf`, this.$getParamsObject(params));
    },
  }
};

export default service;